module.exports = __webpack_public_path__ + "media/images/menu/himalia-7e817d9114b8872b5d02bb19ca67f41d.jpg";